<template>
  <div>
    <spacer :y="5"/>
    <loader-simple :flag="flag.loader">

    <user-box
      v-if="targetUser && mode === 'sender'"
      :showCocomoniBtn="true"
      :ownUser="user"
      :bg="userBoxColor(targetUser)"
      :user="targetUser"
      :showId="true"
      :targetBlank="true"
    />
    <spacer :y="2"/>

    <ul>

      <template v-if="enable_message_send">
        <stack-item>
          <contents-box title="新規メッセージ送信">
            <div>
              <textarea
                :class="$style.textarea"
                rows="5"
                v-model="writingMessage"
                maxlength="100"
              />
              <div :class="$style.textareaCounter">
                {{ writingMessage.length }}/100
              </div>
                <basic-btn
                  tag="button"
                  v-on:click="sendMessage"
                ><i class="fa-regular fa-paper-plane" /> 送信</basic-btn>
            </div>
          </contents-box>
        </stack-item>

        <spacer :y="3"/>
        <hr id="scroll-top" />
        <spacer :y="3"/>
      </template>

      <stack-item id="counselor-message-sent-messages">
        <contents-box :title="messageListTitle">

            <template v-if="!flag.loader && sentMessages.length > 0 && counselorMessageBoxComponentName">
              <stack-item
                :space="2"
                :class="$style.item"
                v-for="(row) in sentMessages"
                :key="row.id">

                <spacer y="1" />

                <component
                  :is="counselorMessageBoxComponentName"
                  :message_group_data="row"
                  :show_new="showNew(row.id)"
                />
              </stack-item>
            </template>

            <p v-if="!flag.loader && sentMessages.length === 0">メッセージはありません</p>

        </contents-box>
      </stack-item>

    </ul>

    </loader-simple>
    <spacer :y="5"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import StackItem from '@/views/components/StackItem.vue';
import ContentsBox from '@/views/components/ContentsBox.vue';
import Spacer from '@/views/components/Spacer.vue';
import LoaderSimple from '@/views/components/LoaderSimple.vue';
import BasicBtn from '@/views/components/BasicBtn.vue';
import UserBox from '@/views/components/UserBox.vue';
import CounselorMessageBoxSimple from '@/views/components/CounselorMessageBoxSimple.vue';
import CounselorMessageBoxRich from '@/views/components/CounselorMessageBoxRich.vue';

import cf from '@/mixins/commonFunctions';

export default {
  name: 'counselor-messages-impl',
  mixins: [
    cf,
  ],
  components: {
    StackItem,
    ContentsBox,
    Spacer,
    LoaderSimple,
    BasicBtn,
    UserBox,
    CounselorMessageBoxSimple,
    CounselorMessageBoxRich,
  },
  props: {
    target_user_id: {
      type: String,
      required: true,
    },
    enable_message_send: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      required: true,
      validator: (value) => ['sender', 'receiver'].includes(value),
    },
  },
  data() {
    return {
      flag: {
        loader: true,
        sending: false,
      },
      targetUser: null,
      clients: [],
      sentMessages: [],
      writingMessage: '',
      readFlags: [],
    };
  },
  created() {
    // 初期表示情報を取得する
    if (this.user && this.user.email) {
      this.initialize();
    } else {
      this.$store.subscribe((mutation) => {
        if (mutation.type === 'user/setUserData') {
          this.initialize();
        }
      });
    }
  },
  computed: {
    ...mapState(['user']),
    messageListTitle() {
      if (this.mode === 'sender') {
        return '送信済みメッセージ';
      }
      if (this.mode === 'receiver') {
        return '先生からのメッセージ';
      }
      return '';
    },
    counselorMessageBoxComponentName() {
      if (this.mode === 'sender') {
        return 'CounselorMessageBoxSimple';
      }
      if (this.mode === 'receiver') {
        return 'CounselorMessageBoxRich';
      }
      return '';
    },
    showNew() {
      return (messageGroupId) => {
        if (this.readFlags.length === 0) {
          return true;
        }
        return !this.readFlags.some((flag) => flag.foreign_id === messageGroupId);
      };
    },
  },
  methods: {
    async initialize() {
      this.flag.loader = true;
      await Promise.all([
        this.getTargetUser(),
        this.getSentMessages(),
        this.getReadflags(),
      ]);
      this.flag.loader = false;

      // 既読フラグを更新
      if (this.mode === 'receiver' && this.targetUser) {
        setTimeout(() => {
          this.updateReadflag();
        }, 3000); // 3秒後に既読フラグを更新
      }
    },

    // 対象ユーザの詳細情報を取得する
    async getTargetUser() {
      try {
        const res = await this.axios({
          method: 'GET',
          url: '/v1/user/get/detail',
          params: {
            id: this.target_user_id,
            isUserWatch: 1, // UserWatchの有無
          },
        });
        this.targetUser = res.data.data || null;
      } catch (error) {
        console.error(error);
        alert('担当ユーザーの取得に失敗しました');
      }
    },

    // 送信済みメッセージ情報を取得する
    async getSentMessages() {
      const params = {
        // user_id: this.user.id,
        target_user_id: this.target_user_id,
        target_type: 3, // 医師心理士から相談者へのメッセージ
        isMessages: 1,
        limit: 99999, // 全件取得
        page: 1,
      };
      try {
        const res = await this.axios({
          method: 'GET',
          url: '/v1/messagegroup/get/listOrderByNewest', // 新着順で取得する
          params,
        });
        this.sentMessages = res.data.groups ? res.data.groups.data : [];
      } catch (error) {
        console.error(error);
        alert('メッセージの取得に失敗しました');
      }
    },

    // 既読フラグを取得する
    async getReadflags() {
      try {
        const res = await this.axios({
          method: 'GET',
          url: '/v1/readflag/get/list',
          params: {
            user_id: this.target_user_id,
            model_type: 5, // 5 => messageGroups
          },
        });
        this.readFlags = res.data.data.data;
      } catch (error) {
        console.error(error);
        alert('既読フラグの取得に失敗しました');
      }
    },

    async sendMessage() {
      if (this.flag.sending) {
        // 多重送信防止
        return;
      }
      this.flag.sending = true;
      try {
        const message = this.writingMessage.trim();
        // 必須入力チェック
        if (!message) {
          alert('メッセージが入力されていません。');
          return;
        }
        // 文字数制限チェック
        if (message.length > 100) {
          alert('メッセージは100文字以内で入力してください。');
          return;
        }
        if (!confirm('メッセージを送信します。この操作は取り消せません。よろしいですか？')) {
          return;
        }

        this.showLoading();

        // 送信処理を実行
        const data = {
          flag: 11, // 医師心理士メッセージは作成時点で11(実施済み)
          user_id: this.user.id, // 送信者
          target_type: 3, // 医師心理士個別メッセージ
          target_user_id: this.target_user_id, // 受信者
          messageData: {
            user_id: this.user.id,
            message,
          },
        };
        const response = await this.axios({
          method: 'POST',
          url: '/v1/messageGroup/set/register',
          data,
        });
        alert('メッセージを送信しました');

        // 通知
        this.axios({
          method: 'POST',
          url: '/v1/contact/regist/counselorMessage',
          data: {
            group_id: response.data.group_id,
          },
        }); // 非同期で実行し、エラーが出ても処理を継続

        // メッセージをクリア
        this.writingMessage = '';

        // 画面表示を更新する
        await this.getSentMessages();
        // メッセージ欄までスクロールする
        const element = document.getElementById('scroll-top');
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth', // スムーズなスクロールを有効にする
            block: 'start', // 要素を可視領域の上端に配置する
          });
        }

      } catch (error) {
        console.error(error);
        alert('メッセージの送信に失敗しました');
      } finally {
        this.flag.sending = false;
        this.hideLoading();
      }
    },

    async updateReadflag() {
      // 処理実行前に既読フラグの最新情報を取得
      await this.getReadflags();

      // 既読更新対象のメッセージの存在チェック
      const messageGroupIds = this.sentMessages.map((msg) => msg.id);
      const readFlagIds = this.readFlags.map((flag) => flag.foreign_id);
      const unreadMessageGroupIds = messageGroupIds.filter((id) => !readFlagIds.includes(id));
      if (unreadMessageGroupIds.length === 0) {
        return;
      }

      // 既読フラグを更新
      try {
        await Promise.all(
          unreadMessageGroupIds.map((id) => this.axios({
            method: 'POST',
            url: '/v1/readflag/set/register',
            data: {
              user_id: this.target_user_id,
              model_type: 5, // 5 => messageGroups
              foreign_id: id,
            },
          })),
        );
        this.$store.dispatch('user/update'); // ユーザー情報を更新
      } catch (error) {
        console.error(error);
        alert('既読フラグの更新に失敗しました');
      }
    },

    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング非表示 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },
  },
};
</script>

<style lang="scss" module>
.textarea {
  width: 100%;
  background-color: var(--gray-sub);
  border: none;
  outline: none;
  padding: 20px;
  border-radius: 8px;
}

.textareaCounter {
  text-align: right;
  font-size: 12px;
  color: #888;
}
</style>
